import React from 'react';
import {
  SectionIntroText,
  WhenToContactItem,
  WhenToContactList,
  WhenToContactTitle,
} from './styles';

type ContactSectionInfoProps = {
  intro: string;
  whenToContactTitle: string;
  topics: string[];
};

const ContactSectionInfo = ({
  intro,
  whenToContactTitle,
  topics,
}: ContactSectionInfoProps): JSX.Element => (
  <>
    <SectionIntroText>{intro}</SectionIntroText>
    <WhenToContactTitle>{whenToContactTitle}</WhenToContactTitle>
    <WhenToContactList>
      {topics.map((topic) => (
        <WhenToContactItem key={topic}>{topic}</WhenToContactItem>
      ))}
    </WhenToContactList>
  </>
);

export default ContactSectionInfo;
